import type { Metric } from "../../components/MetricStrip";
import { formatActivityMoney, formatActivityQuantity } from "../driver-activity-format";
import type { ActivityStats } from "../driver-activity-view-model";

/** The day's totals for the footer strip, most important first; the legacy viewer's stats footer. */
export const buildDayMetrics = (stats: ActivityStats, { showRevenue }: { showRevenue: boolean }): Metric[] => [
  { id: "drivers", label: "Drivers", value: stats.drivers, priority: 40 },
  { id: "loads", label: "Loads", value: stats.loads, priority: 10 },
  { id: "volume", label: "Volume", value: formatActivityQuantity(stats.quantity, stats.quantityUom), priority: 20 },
  {
    id: "revenue",
    label: "Revenue / Cost",
    value: `${formatActivityMoney(stats.revenue)} / ${formatActivityMoney(stats.cost)}`,
    tone: "primary",
    hidden: !showRevenue,
    priority: 15,
  },
  {
    id: "subcontractor",
    label: "Subs",
    value: formatActivityMoney(stats.subcontractor),
    tooltip: "What subcontractors charge for the day's tickets.",
    hidden: !showRevenue || stats.subcontractor <= 0,
    priority: 16,
  },
  {
    id: "scada",
    label: "SCADA calculated",
    value: `${stats.scada.calculated}/${stats.scada.known}`,
    tone: stats.scada.known === 0 ? "neutral" : stats.scada.calculated === stats.scada.known ? "success" : "warning",
    tooltip: "Pickups with a SCADA quantity, out of those SCADA was attempted for.",
    hidden: stats.scada.known === 0,
    priority: 30,
  },
  {
    id: "audit",
    label: "Audit blocked",
    value: stats.auditBlocked,
    tone: "danger",
    tooltip: "Tickets whose latest audit has a blocking finding.",
    hidden: stats.auditBlocked === 0,
    priority: 4,
  },
  { id: "attention", label: "Needs review", value: stats.attention, tone: "warning", hidden: stats.attention === 0, priority: 5 },
  {
    id: "missing",
    label: "Missing",
    value: stats.unmatched,
    tone: "warning",
    tooltip: "Tickets with a pickup or a delivery, but not both.",
    hidden: stats.unmatched === 0,
    priority: 25,
  },
];
